import { render, staticRenderFns } from "./PendingInvestment.vue?vue&type=template&id=d9dc5376"
import script from "./PendingInvestment.vue?vue&type=script&lang=js"
export * from "./PendingInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports